import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionsGuard } from '@core/guard/permissions.guard';
import { PageConfigPresorteoCreateComponent } from './page-config-presorteo-create/page-config-presorteo-create.component';
import { PageConfigPresorteoEditComponent } from './page-config-presorteo-edit/page-config-presorteo-edit.component';
import { PageConfigPresorteoListComponent } from './page-config-presorteo-list/page-config-presorteo-list.component';

const routes: Routes = [
  {
    path: '',
    component: PageConfigPresorteoListComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['core.config.presorteo'] }
  },
  {
    path: 'create',
    component: PageConfigPresorteoCreateComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['core.config.presorteo'] }
  },
  {
    path: 'edit/:id',
    component: PageConfigPresorteoEditComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['core.config.presorteo'] }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesConfigPresorteoCoreRoutingModule { }
